































































































































































































































































































































































































































import { Component, Prop, Watch } from "vue-property-decorator";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import BaseFormulirCard from "@/BaseFormulirCard.vue";
import CommonSuket, { EnFormulirCategory } from "@/services/CommonFormulir";
import BaseFormulir from "@/BaseFormulir";

import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import { storePasien } from "@/store/modules/pasien";
import { storeDokter } from "@/store/modules/dokter";

import pdf from "vue-pdf";
import moment from "moment";
import http from "@/axios/http-common";
import FormulirKlaimRehabMedik from "@/store/modules/FormulirKlaimRehabMedik";
import DialogPilihPenunjang from "@/components/pemeriksaan/rehabmedik/DialogPilihPenunjang.vue";
import SoapDokterSvc from "@/services/SoapDokter";
import SuratKonsulSvc from "@/services/new/SuratKonsul";
import DataResume from "@/services/DataResume";
import {
  mapResumeToIcd,
  mergeIcdRows,
  pickRujukanMasuk,
  pickSoapForRegister
} from "@/utils/klaimRehabMedik";

interface IcdRow {
  kode: string;
  nama: string;
}

interface IcdPickerRow {
  selected: { label: string; value: string } | null;
  search: string | null;
  options: Array<{ label: string; value: string }>;
  loading: boolean;
  timer: number | null;
  kode: string | null;
  nama: string | null;
}

function makePickerRow(preset?: IcdRow): IcdPickerRow {
  return {
    selected: preset
      ? { label: `${preset.kode} - ${preset.nama}`, value: preset.kode }
      : null,
    search: null,
    options: preset
      ? [{ label: `${preset.kode} - ${preset.nama}`, value: preset.kode }]
      : [],
    loading: false,
    timer: null,
    kode: preset?.kode ?? null,
    nama: preset?.nama ?? null
  };
}

@Component({
  components: {
    CardModalTtd,
    BaseFormulirCard,
    DialogPilihPenunjang,
    pdf
  }
})
export default class FormulirKlaimRehabMedikTabPage extends BaseFormulir {
  @Prop() declare readonly register: string | number;

  allowedUnit = ["*"];
  formSvc = new CommonSuket(EnFormulirCategory.KlaimRehabMedis);
  formStore = FormulirKlaimRehabMedik;

  get pdfUrl() {
    return this.dataForm
      ? this.getPdfUrl(EnFormulirCategory.KlaimRehabMedis, this.dataForm.id)
      : null;
  }

  register_id: string | number = this.register;
  pasien_rm: string | null = this.pasien?.rm ?? null;
  unit_id: string | null = this.user?.unit_id ?? null;
  nama: string | null = this.pasien?.nama ?? null;

  surat_date = moment().format("YYYY-MM-DD");
  signee_user_id = this.user.id;
  creator_user_id = this.user.id;
  alamat_type = "ktp";

  today = moment().format("YYYY-MM-DD");
  tglPelayanan = moment().format("YYYY-MM-DD");
  tglPelayananShow = false;
  suratDateShow = false;

  validasi = [v => !!v || "*Kolom ini harus diisi"];
  saving = false;
  loadedRatio = 0;
  tarikLoading = false;
  tarikOtomatisUntuk: string | number | null = null;
  dialogPenunjang = false;

  anamnesa: string | null = null;
  pemeriksaanFisik: string | null = null;
  penunjang: string | null = null;
  anjuran: string | null = null;
  evaluasi: string | null = null;
  suspekPakStatus: string | null = null;
  suspekPakKeterangan: string | null = null;

  diagnosisMedis: IcdPickerRow[] = [];
  tataLaksanaKfr: IcdPickerRow[] = [];

  tglRujukan: string | null = null;
  tglRujukanShow = false;
  dokterPerujuk: number | null = null;

  mounted() {
    this.changedataForm(this.dataForm);
  }

  get pasien() {
    return storePasien.identitasPasien;
  }

  get user() {
    return userModule.user;
  }

  get listDokter() {
    return storeDokter.list;
  }

  get canSign() {
    return this.user.id == this.signee_user_id;
  }

  get input() {
    const mapRows = (rows: IcdPickerRow[]): IcdRow[] => this.mapPickerRows(rows);

    return {
      register_id: this.register_id,
      pasien_rm: this.pasien_rm,
      unit_id: this.unit_id,
      content: {
        tgl_rujukan: this.tglRujukan,
        dokter_perujuk: this.dokterPerujuk,
        tgl_pelayanan: this.tglPelayanan,
        anamnesa: this.anamnesa,
        pemeriksaan_fisik: this.pemeriksaanFisik,
        diagnosis_medis: mapRows(this.diagnosisMedis),
        diagnosis_fungsi: [],
        penunjang: this.penunjang,
        tata_laksana_kfr: mapRows(this.tataLaksanaKfr),
        anjuran: this.anjuran,
        evaluasi: this.evaluasi,
        suspek_pak: {
          status: this.suspekPakStatus,
          keterangan:
            this.suspekPakStatus === "ya" ? this.suspekPakKeterangan : null
        }
      },
      surat_date: this.surat_date,
      signee_user_id: this.signee_user_id,
      creator_user_id: this.creator_user_id
    };
  }

  addDiagnosisMedis() {
    this.diagnosisMedis.push(makePickerRow());
  }
  removeDiagnosisMedis(i: number) {
    this.diagnosisMedis.splice(i, 1);
  }
  addTataLaksana() {
    this.tataLaksanaKfr.push(makePickerRow());
  }
  removeTataLaksana(i: number) {
    this.tataLaksanaKfr.splice(i, 1);
  }

  onSelectDiagnosisMedis(val, i: number) {
    this.applyIcdSelection(this.diagnosisMedis, i, val);
  }
  onSelectTataLaksana(val, i: number) {
    this.applyIcdSelection(this.tataLaksanaKfr, i, val);
  }

  private applyIcdSelection(rows: IcdPickerRow[], i: number, val) {
    if (!val) return;
    const row = rows[i];
    if (!row) return;
    row.kode = val.value;
    const label: string = val.label ?? "";
    // Backend returns "KODE || Nama diagnosa" format
    const sep = label.indexOf(" || ");
    if (sep >= 0) {
      row.nama = label.substring(sep + 4).trim();
    } else {
      const dash = label.indexOf(" - ");
      row.nama = dash >= 0 ? label.substring(dash + 3).trim() : label;
    }
  }

  private setupIcdSearch(
    rows: IcdPickerRow[],
    i: number,
    term: string | null,
    endpoint: string
  ) {
    const row = rows[i];
    if (!row) return;
    if (row.timer) {
      clearTimeout(row.timer);
      row.timer = null;
    }
    // Skip if term unchanged (e.g. v-autocomplete emits search=selected label)
    if (row.selected && term === row.selected.label) return;
    if (!term || term.length < 2) return;
    row.loading = true;
    row.timer = window.setTimeout(() => {
      http
        .getDataParam(endpoint, { params: { term } })
        .then(res => {
          row.options = res.data;
        })
        .finally(() => {
          row.loading = false;
          row.timer = null;
        });
    }, 400);
  }

  onSearchDiagnosisMedis(term: string | null, i: number) {
    this.setupIcdSearch(
      this.diagnosisMedis,
      i,
      term,
      "/referensi/diagnosis-icd/search"
    );
  }
  onSearchTataLaksana(term: string | null, i: number) {
    this.setupIcdSearch(
      this.tataLaksanaKfr,
      i,
      term,
      "/referensi/prosedur-icd/search"
    );
  }

  save() {
    if (this.saving) return;

    if (!this.diagnosisMedis.some(r => r.kode && r.nama)) {
      appModule.sendErrorAlert(
        "Diagnosis Akhir (ICD-10) wajib diisi minimal 1."
      );
      return;
    }
    if (!this.tataLaksanaKfr.some(r => r.kode && r.nama)) {
      appModule.sendErrorAlert(
        "Tata Laksana KFR (ICD 9CM) wajib diisi minimal 1."
      );
      return;
    }
    if (!this.suspekPakStatus) {
      appModule.sendErrorAlert(
        "Suspek Penyakit Akibat Kerja wajib dipilih (Ya/Tidak)."
      );
      return;
    }
    if (this.suspekPakStatus === "ya" && !this.suspekPakKeterangan) {
      appModule.sendErrorAlert(
        "Keterangan Suspek Penyakit Akibat Kerja wajib diisi."
      );
      return;
    }

    this.saving = true;

    const action = this.dataForm
      ? this.formSvc.update(this.dataForm.id, this.input)
      : this.formSvc.create(this.input);

    action
      .then(() => {
        if (this.canSign) {
          this.showSignatureModal();
        }
        appModule.NoticeDelay("Berhasil Simpan");
        this.close();
        this.formStore.getByRegister(this.register);
      })
      .finally(() => {
        this.saving = false;
      });
  }

  close() {
    this.expandInput = false;
  }

  tglPelayananFormat() {
    return this.tglPelayanan
      ? moment(this.tglPelayanan, "YYYY-MM-DD").format("DD MMMM YYYY")
      : "";
  }

  tglRujukanFormat() {
    return this.tglRujukan
      ? moment(this.tglRujukan, "YYYY-MM-DD").format("DD MMMM YYYY")
      : "";
  }

  suratDateFormat() {
    return this.surat_date
      ? moment(this.surat_date, "YYYY-MM-DD").format("DD MMMM YYYY")
      : "";
  }

  @Watch("dataForm")
  changedataForm(val) {
    if (val) {
      const c = val.content ?? {};
      this.register_id = val.register_id;
      this.pasien_rm = val.pasien_rm?.toString() ?? this.pasien?.rm ?? null;
      this.nama = val.pasien?.nama ?? this.pasien?.nama ?? null;
      this.surat_date = val.surat_date;
      this.signee_user_id = val.signee_user_id;
      this.creator_user_id = val.creator_user_id;

      this.anamnesa = c.anamnesa ?? null;
      this.pemeriksaanFisik = c.pemeriksaan_fisik ?? null;
      this.penunjang = c.penunjang ?? null;
      this.anjuran = c.anjuran ?? null;
      this.evaluasi = c.evaluasi ?? null;
      this.suspekPakStatus = c.suspek_pak?.status ?? null;
      this.suspekPakKeterangan = c.suspek_pak?.keterangan ?? null;

      this.diagnosisMedis = mergeIcdRows(
        Array.isArray(c.diagnosis_medis) ? c.diagnosis_medis : [],
        Array.isArray(c.diagnosis_fungsi) ? c.diagnosis_fungsi : []
      ).map((r: IcdRow) => makePickerRow(r));
      this.tataLaksanaKfr = Array.isArray(c.tata_laksana_kfr)
        ? c.tata_laksana_kfr.map((r: IcdRow) => makePickerRow(r))
        : [];

      this.tglPelayanan = c.tgl_pelayanan || this.today;
      this.tglRujukan = c.tgl_rujukan ?? null;
      this.dokterPerujuk = c.dokter_perujuk ?? null;
    } else {
      this.register_id = this.register;
      this.pasien_rm = this.pasien.rm;
      this.unit_id = this.user.unit_id;
      this.nama = this.pasien.nama;
      this.surat_date = moment().format("YYYY-MM-DD");
      this.signee_user_id = this.user.id;
      this.creator_user_id = this.user.id;
      this.tglPelayanan = moment().format("YYYY-MM-DD");

      this.anamnesa = null;
      this.pemeriksaanFisik = null;
      this.penunjang = null;
      this.anjuran = null;
      this.evaluasi = null;
      this.suspekPakStatus = null;
      this.suspekPakKeterangan = null;

      this.diagnosisMedis = [];
      this.tataLaksanaKfr = [];

      this.tglRujukan = null;
      this.dokterPerujuk = null;

      if (!this.isReadOnly && this.tarikOtomatisUntuk !== this.register) {
        this.tarikOtomatisUntuk = this.register;
        this.tarikDariRme({ silent: true });
      }
    }
  }

  terapkanPenunjang(teks: string) {
    if (!teks) return;

    this.penunjang = this.penunjang ? `${this.penunjang}\r\n${teks}` : teks;
  }

  async tarikDariRme(opts: { silent: boolean }) {
    if (this.isReadOnly || this.tarikLoading) return;

    const reg = this.register;
    if (!reg) return;

    if (
      !opts.silent &&
      (this.anamnesa || this.pemeriksaanFisik) &&
      !confirm(
        "Anamnesa dan Pemeriksaan Fisik akan ditimpa hasil tarik. Kode ICD yang sudah diisi tetap dipertahankan. Lanjutkan?"
      )
    ) {
      return;
    }

    this.tarikLoading = true;

    try {
      const [soap, resume, konsul] = await Promise.all([
        SoapDokterSvc.getByRegister(reg).catch(() => null),
        DataResume.getDataResume(reg, "").catch(() => null),
        SuratKonsulSvc.getKonsulMasukByReg(reg).catch(() => null)
      ]);

      if (String(reg) !== String(this.register)) return;

      const terisi: string[] = [];

      const soapDipakai = pickSoapForRegister(
        (soap && soap.data) || [],
        reg,
        this.user.id
      );

      if (soapDipakai?.s) {
        this.anamnesa = soapDipakai.s;
        terisi.push("Anamnesa");
      }
      if (soapDipakai?.o) {
        this.pemeriksaanFisik = soapDipakai.o;
        terisi.push("Pemeriksaan Fisik");
      }

      const icd = mapResumeToIcd((resume && resume.data) || [], reg);

      if (icd.diagnosis.length) {
        this.diagnosisMedis = mergeIcdRows(
          this.mapPickerRows(this.diagnosisMedis),
          icd.diagnosis
        ).map(r => makePickerRow(r));
        terisi.push("Diagnosis Akhir");
      }
      if (icd.prosedur.length) {
        this.tataLaksanaKfr = mergeIcdRows(
          this.mapPickerRows(this.tataLaksanaKfr),
          icd.prosedur
        ).map(r => makePickerRow(r));
        terisi.push("Tata Laksana KFR");
      }

      const rujukan = pickRujukanMasuk(
        (konsul && konsul.data && konsul.data.suratKonsul) || [],
        this.user.unit_group_id
      );

      if (rujukan?.dokterId) {
        this.dokterPerujuk = rujukan.dokterId;
        terisi.push("Rujukan dari dokter");
      }
      if (rujukan?.tanggal) {
        this.tglRujukan = rujukan.tanggal;
        terisi.push("Tanggal Rujukan");
      }

      if (opts.silent) return;

      if (terisi.length) {
        appModule.NoticeDelay(`Terisi dari RME: ${terisi.join(", ")}`);
      } else {
        appModule.sendErrorAlert(
          "Belum ada SOAP, diagnosis, atau rujukan pada kunjungan ini"
        );
      }
    } finally {
      this.tarikLoading = false;
    }
  }

  private mapPickerRows(rows: IcdPickerRow[]): IcdRow[] {
    return rows
      .filter(r => r.kode && r.nama)
      .map(r => ({ kode: r.kode as string, nama: r.nama as string }));
  }
}
